<template>
  <el-container>
    <el-aside width="265px" class="leftside">
      <img class="logoimg" src="../assets/logo.png" />
      <el-menu
        text-color="white"
        background-color="transparent"
        router
        :default-active="$route.path"
        unique-opened
      >
        <el-menu-item index="/">
          <i class="el-icon-s-home"></i>
          <span>管理首页</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin()" index="/matches">
          <i class="el-icon-s-grid"></i>
          <span>比赛列表</span>
        </el-menu-item>
        <el-menu-item v-else index="/matches">
          <i class="el-icon-s-grid"></i>
          <span>我的比赛</span>
        </el-menu-item>
        <el-menu-item v-role="['3','1']" index="/articles">
          <i class="el-icon-share"></i>
          <span>消息通知</span>
        </el-menu-item>
        <el-menu-item v-role="['2']" index="/teamplayers">
          <i class="el-icon-share"></i>
          <span>选手管理&nbsp;&nbsp;</span>
        </el-menu-item>

        <el-menu-item v-role="['1']" index="/accounts">
            <i class="el-icon-s-custom"></i>
            <span>账户管理</span>
          </el-menu-item>
          <el-menu-item v-role="['1']" index="/hosts">
            <i class="el-icon-menu"></i>
            <span>主办方</span>
          </el-menu-item>
          <el-menu-item  v-role="['1']" index="/teams">
            <i class="el-icon-share"></i>
            <span>代表队&nbsp;&nbsp;</span>
          </el-menu-item>
           <el-menu-item v-role="['1']" index="/playerlist">
            <i class="el-icon-share"></i>
            <span>选手管理</span>
          </el-menu-item>   
             <el-menu-item v-role="['1']" index="/approve">
            <i class="el-icon-share"></i>
            <span>实名审核</span>
          </el-menu-item>    
           <el-menu-item v-role="['2']" index="/teamApprove">
            <i class="el-icon-share"></i>
            <span>实名审核</span>
          </el-menu-item>    
      </el-menu>
    </el-aside>
    <el-container>
      <el-header>
        <el-row type="flex" class="toolbar" justify="space-between">
          <el-col :span="4"
            ><el-input
              size="small"
              class="search-input"
              prefix-icon="el-icon-search"
              placeholder="请输入内容"
            >
            </el-input
          ></el-col>
          <el-col :span="6" style="text-aligin: right">
            <div style="text-align: right">
              <el-dropdown trigger="click" style="margin-right: 10px">
                <div class="el-dropdown-link">
                  <span
                    ><el-avatar
                      class="userawater"
                      icon="el-icon-user-solid"
                      shape="square"
                      :src="awatar"
                      size="small"
                    ></el-avatar></span
                  ><span>{{ name }}</span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div @click="changepassword">
                      <span style="color: #555; font-size: 14px">修改密码</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item divided @click.native="logout"
                    >退出登录</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <el-badge is-dot class="el-icon-bell" style="margin-right: 10px">
              </el-badge>

              <i class="el-icon-switch-button" @click="logout"> </i>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
export default {
  data () {
    return {
      name: sessionStorage.getItem('name'),
      awatar: sessionStorage.getItem('awatar') === null ? "" : sessionStorage.getItem('awatar')
    }
  },
  methods: {
    isAdmin () {
      return sessionStorage.getItem('userType') == "1"
    },
    changepassword () {
      this.$router.push('/changepassword')
    },
    logout () {
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonClass: 'el-button--warning'
      })
        .then(() => {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('uid');
          sessionStorage.removeItem('refresh_token');
          sessionStorage.removeItem('userType');
          sessionStorage.removeItem('expireTime');
          this.loading = true;
          this.$router.push('/login'); //用go刷新
        })
        .catch(() => { });
    }
  }
}
</script>
<style scoped>
html,
body,
#app,
.el-container {
  padding: 0px;
  margin: 0px;
  height: 100%;
  background: #eee;
}
.toolbar {
  height: 32px;
}
.logoimg {
  margin-top: 17px;
}
.el-header {
  line-height: 60px;
}
.search-input {
  height: 32px;
}
.userawater {
  margin-top: 16px;
  float: left;
}
.leftside {
  background-image: url(../assets/leftbackground.png);
  background-repeat: repeat-y;
  width: 100%;
}
.el-menu-item.is-active {
  background-color: wheat !important;
  background: wheat;
  color: #333;
}
.el-card__header {
  text-align: left;
}
.el-main {
  /*background: #eaf4f6;*/
  background: #eee;
}
</style>


// WEBPACK FOOTER //
// src/views/Layout.vue